import type { Theme } from '../../types/theme';

export const posthogTheme: Theme = {
  id: 'posthog',
  name: 'PostHog',
  description: 'Warm cream canvas with playful yellow-orange CTA, hedgehog mascot',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/posthog/DESIGN.md',
  visualKeywords: ['warm cream', 'playful', 'hedgehog mascot', 'yellow CTA', 'developer-friendly'],
  colors: {
    background: '#eeefe9',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#23251d',
    textSecondary: '#4d4f46',
    textMuted: '#4d4f46',
    border: '#bfc1b7',
    borderSubtle: '#b5b7ad',
    primary: '#f7a501',
    primaryHover: '#e39100',
    primaryActive: '#d98700',
    accent: '#f7a501',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'playful',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
